import Vue from "vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

Vue.component("wto-ck-editor", {
	props: ["viewModelData", "hasSource"],
	computed: {
		computedValue: {
			get() {
				return !this.viewModelData ? "" : this.viewModelData;
			},
			set(value) {
				this.$emit("update:viewModelData", value);
			}
		},
		editorConfig() {
			let returnValue = {
				toolbar: {
					items: ['bold', 'italic', 'subscript', 'superscript', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'insertTable',  '|', 'undo', 'redo']
				},
				table: {
					contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
				}
			};

			if (this.hasSource) {
				returnValue = {
					toolbar: {
						items: ['bold', 'italic', 'subscript', 'superscript', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'sourceEditing', 'mediaEmbed', 'insertImage', '|', 'insertTable', '|', 'undo', 'redo']
					},
					table: {
						contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
					}
				};
			}
			
			return returnValue;
		},
	},
	data() {
		return {
			editor: ClassicEditor
		};
	},
	template: `
	   <ckeditor tag-name="textarea" :editor="editor" v-model="computedValue" :config="editorConfig" expanded></ckeditor>       
	`
});